<template>
  <div>
    <b-modal v-model="fileUploadModal" :width="800" animation="zoom-out" @close="$emit('closeFileUploadModal')">
      <form enctype="multipart/form-data">
        <div class="model-card">

          <header class="modal-card-head">
            <p class="modal-card-title"></p>
            <button @click="fileUploadModal = false" type="button" class="delete"></button>
          </header>

          <div class="modal-card-body">
            <div class="content pt-2">
              <div class="columns is-gapless">
                <div class="column is-2">
                  <div class="item">
                    <img :src="require('@/assets/icon/Library.png')" alt="library-icon">
                    <p style="color: #0D5DA3">Library</p>
                  </div>
                  <div class="item">
                    <img :src="require('@/assets/icon/scan.png')" alt="Scan-icon">
                    <p style="color: #0D5DA3">Scan</p>
                  </div>
                  <div class="item">
                    <b-upload class="file-label" @input="handleFile" type="file" id="inputfile" multiple >
                      <img :src="require('@/assets/icon/files.png')" alt="Files-icon">
                    </b-upload>
                    <p style="color: #0D5DA3">Files</p>
                  </div>
                  <div class="item">
                    <img :src="require('@/assets/icon/drive.png')" alt="Drive-icon">
                    <p style="color: #0D5DA3">Drive</p>
                  </div>
                  <div class="item">
                    <img :src="require('@/assets/icon/template.png')" alt="Template-icon">
                    <p style="color: #0D5DA3">Templates</p>
                  </div>
                </div>
<!--                <div class="column">-->
<!--                  <div class="area">-->
<!--                    <p v-if="file">{{file.name}}</p>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>

        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>

import axios from "axios";

export default {

  name:'FileUploadComp',



  components:{

  },

  data() {

    return {

      fileUploadModal:true
    }
  },

  methods:{
    //upload file
    handleFile:function (){
      var component = this

      if(event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){

        const filesize = Math.round(( event.target.files[0].size / 1024));
        // The size of the file.
        if (filesize >= 50000) {
          component.$buefy.toast.open({
            message: 'Please select a file less than 50mb',
            type: 'is-danger',
            duration:2000
          })

        } else{

          let formData = new FormData();
          formData.append('file', event.target.files[0]);

          axios.post(component.$base_url+'/wordToPdf', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
              .then(function (response){

                component.$root.file_url = response.data.file_path;

                let FileData = {
                  currentFileURL:response.data.file_path
                }

                component.$emit('file-uploaded',FileData);

              }).catch(function (error) {
            console.log(error);
          });

        }
      }

      else if(event.target.files[0].type == 'application/pdf'){
        console.log('file upload function------')
        const filesize = Math.round(( event.target.files[0].size / 1024));
        // The size of the file.
        if (filesize >= 50000) {
          component.$buefy.toast.open({
            message: 'Please select a file less than 50mb',
            type: 'is-danger',
            duration:2000
          })

        } else{
          // component.filename = "Selected File: " + event.target.files[0].name;
          component.$root.file_url = event.target.files[0];
          console.log('files on change-------------------------------------')
          console.log(event.target.files)
          let FileData = {
            files:event.target.files,
            currentFileURL:URL.createObjectURL(event.target.files[0])
          }



          component.$emit('file-uploaded',FileData);
          // if(component.currentFileUrl){
          //   component.filUploadModal =false
          //   component.showLoadingModal =true
          //   component.countDownTimer()
          // }
        }

      } else{

        component.$buefy.toast.open({
          message: 'The selected file type should be PDF or Docx',
          type: 'is-danger',
          duration:2000
        })

      }


    }
  },

  mounted() {


  }

}
</script>

<style scoped>

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.modal-card-body{
  border-radius: 0 0 5px 5px;
}


.item img{
  width: 60px;

}

.item{
  padding: 10px 10px 10px 30px;
  border-top-left-radius: 100%;
  border-bottom-left-radius: 100%;
}

.item:hover{
  background-color: #F2F4FF;
}







</style>
